import React, { useEffect, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { AiOutlineSearch } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { useCurrent } from '../../../hooks';
import useFetch from '../../../hooks/useFetch';  

const OsMwSelectorAccount = ({
    onChangeCallback,
    withLabel = false,
    invalid = false,
    initalValue = '',
    disabled = false,
}) => {
    const [t] = useTranslation('global');
    const { currentLangId } = useCurrent();
    const [inputValue, setInputValue] = useState(initalValue);
    const [selectedItem, setSelectedItem] = useState(null);
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [initialAccountData, setInitialAccountData] = useState(null);
  
    const { data, loading } = useFetch(
        initalValue 
          ? `https://emdad.sellatechnology.com/acc/api/tree-account/search/${initalValue}`
          : (searchTerm 
              ? `https://emdad.sellatechnology.com/acc/api/tree-account/search/${searchTerm}`
              : null)
    );
  
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.mw-selector-container')) {
                setOpen(false);
            }
        };
  
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
  
    const handleAccountSelect = (account) => {
        // const displayValue = `${account.account_no}/${account.name_ar}/${account.name_en}`;
         // دالة حذف الأرقام
    const removeNumbers = (str) => (str || '').replace(/[0-9]/g, '');
    
    // معالجة الأسماء
    const cleanNameAr = removeNumbers(account.name_ar || '');
    const cleanNameEn = removeNumbers(account.name_en || '');
    
    // بناء القيمة المعروضة
    const displayValue = cleanNameAr === cleanNameEn 
        ? `${account.account_no}/${account.name_ar}`
        : `${account.account_no}/${account.name_ar}/${account.name_en}`;
        
        setSelectedItem(account);
        setInputValue(displayValue);
        setSearchTerm('');
        onChangeCallback(account);
        setOpen(false);
    };
  
    const handleInputClick = (e) => {
        if (!disabled) {
            e.stopPropagation();
            setOpen(prevOpen => !prevOpen);
        }
    };
  
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setSearchTerm(value);
        setOpen(true);
    };
  
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
    };
    useEffect(() => {
        const removeNumbers = (str) => str.replace(/[0-9]/g, '');  
    
        if (initalValue) {
            const fetchInitialAccount = async () => {
                try {
                    const response = await fetch(`https://emdad.sellatechnology.com/acc/api/tree-account/search/${initalValue}`);
                    const result = await response.json();
                    if (result.data && result.data.length > 0) {
                        const account = result.data[0];
                        
                         const nameArWithoutNumbers = removeNumbers(account.name_ar);
                        const nameEnWithoutNumbers = removeNumbers(account.name_en);
                        
                        const displayValue = nameArWithoutNumbers === nameEnWithoutNumbers 
                            ? `${account.account_no}/${account.name_ar}`
                            : `${account.account_no}/${account.name_ar}/${account.name_en}`;
    
                        setInputValue(displayValue);
                        setSelectedItem(account);
                    }
                } catch (error) {
                    console.error('Error fetching initial account:', error);
                }
            };
            
            fetchInitialAccount();
        }
    }, [initalValue]);

  
    return (
        <div className="relative mw-selector-container">
            {withLabel && (
                <label className="text-xs text-slate-500">
                    {t('invoice.selectAccount')}
                </label>
            )}
        
            <div
                onClick={handleInputClick}
                className={`h-9 bg-white w-full border flex items-center text-sm justify-between rounded ${
                    invalid ? 'border border-red-400' : ''
                } ${disabled ? 'text-slate-200' : 'text-slate-300'}`}
            >
                <input
                    type="text"
                    disabled={disabled}
                    value={inputValue}
                    className="text-start px-3 border-0 text-black font-bold w-full"
                    onChange={handleInputChange}
                    onClick={handleInputClick}
                />
                <BiChevronDown size={20} className="border rounded m-2" />
            </div>
  
            {open && (
                <ul 
                    className="bg-white border-b-2 border-x-2 z-50 overflow-y-auto absolute w-full rounded-b-lg max-h-60"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="sticky top-0 p-3 bg-white">
                        <div className="flex items-center justify-between px-2 bg-white rounded">
                            <AiOutlineSearch size={18} className="text-gray-700" />
                            <input
                                type="text"
                                placeholder="Enter Account Name"
                                className="placeholder:text-gray-700 p-2 outline-none w-full text-sm bg-white text-black"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
  
                    {loading && <div className="p-4 text-center">Loading...</div>}
  
                    <div className="max-h-[300px] overflow-y-auto">
                        {initialAccountData && (
                            <li
                                key={initialAccountData.id}
                                onClick={() => handleAccountSelect(initialAccountData)}
                                className="ps-5 py-2 border-b text-sm hover:bg-sky-200 hover:text-white cursor-pointer"
                            >
                                <div className="flex justify-between">
                                    <div>
                                        <div className="text-black">
                                            {currentLangId === 'ar' ? initialAccountData.name_ar : initialAccountData.name_en}
                                        </div>
                                        <div className="text-xs text-slate-400">
                                            {initialAccountData.account_no}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        )}
                        {!loading && data?.data?.map((account) => (
                            <li
                                key={account.id}
                                onClick={() => handleAccountSelect(account)}
                                className="ps-5 py-2 border-b text-sm hover:bg-sky-200 hover:text-white cursor-pointer"
                            >
                                <div className="flex justify-between">
                                    <div>
                                        <div className="text-black">
                                            {currentLangId === 'ar' ? account.name_ar : account.name_en}
                                        </div>
                                        <div className="text-xs text-slate-400">
                                            {account.account_no}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </div>
                </ul>
            )}
        </div>
    );
};

export default OsMwSelectorAccount;